import api from "../../utils/apiUserTienda";   

export async function obtenerConfiguracionTiendaService() {
  try {
    const response = await api.get("/api/tienda/configuracion");

    return {
      ok: true,
      data: response.data?.data || null,
      message: response.data?.message || "",
    };
  } catch (error) {
    return {
      ok: false,
      data: null,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "No se pudo obtener la configuración de la tienda.",
    };
  }
}